import React from 'react';
import Spinner from '../Spinner/Spinner';
import './LoadingOverlay.scss'

export default function LoadingOverlay({
    classes,
    fadeClasses,
}) {

    return (
        <section className={ `${classes} w-100 h-100`}>
            <div className="spinner-position d-flex align-items-center justify-content-center">
                <div className={ `${fadeClasses}` }>
                    <Spinner spinClasses={ "fast-spin" } />
                </div>
            </div>
        </section>
    );
}